let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ekztv")).then(() => parcelRequire('eVv9d'));